import { useCallback, useEffect, useState } from 'react';

import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';

import { MODAL_PARAM_KEY } from '#client/pages/Home/constants';
import { appendUrlParam, getUrlParam, removeUrlParam } from '#client/pages/Home/utils';

import AccountHolder from './AccountHolder';
import ConnectWithPartners from './ConnectWithPartners';

import EditModal from './Modals/EditAccount';
import OptOutModal from './Modals/OptOut';
import useStyles from './useStyles';

const AccountSettings = ({ account, loading, refresh }) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const [currentModal, setCurrentModal] = useState(null);
  const { allPartnerOptOut } = account;

  const handleOpenModal = useCallback((modal) => {
    setCurrentModal(modal);
    appendUrlParam({
      navigate,
      location,
      paramName: modal,
      paramKey: MODAL_PARAM_KEY
    });
  }, [navigate, location]);

  const handleCloseModal = () => {
    setCurrentModal(null);
    removeUrlParam({ navigate, location, paramKey: MODAL_PARAM_KEY });
  };

  useEffect(() => {
    const modalName = getUrlParam(location, MODAL_PARAM_KEY);
    if (!modalName || currentModal) return;
    handleOpenModal(modalName);
  }, [currentModal, handleOpenModal, location]);

  return (
    <section className={classes.root}>
      <Title
        level={1}
        variant="lg-alt"
        className={classes.heading1}
      >
        Account Settings
      </Title>
      <AccountHolder account={account} loading={loading} onClickEdit={() => handleOpenModal('editAccount')} />
      <ConnectWithPartners
        account={account}
        loading={loading}
        onClickOptOut={() => handleOpenModal('optOut')}
      />
      <EditModal
        isOpen={currentModal === 'editAccount'}
        onClose={() => handleCloseModal('editAccount')}
        account={account}
      />
      {!allPartnerOptOut
        && (
        <OptOutModal
          isOpen={currentModal === 'optOut'}
          onClose={() => handleCloseModal('optOut')}
          refresh={refresh}
        />
        )}
    </section>
  );
};

AccountSettings.propTypes = {
  account: PropTypes.shape({
    allPartnerOptOut: PropTypes.bool
  }).isRequired,
  loading: PropTypes.bool,
  refresh: PropTypes.func.isRequired
};

export default AccountSettings;
